<template>
  <teleport to="body">
    <transition name="modal-fade">
      <div v-if="show !== false" @click.self="close" class="fixed inset-0 bg-black bg-opacity-70 z-40 flex justify-center items-center">
        <div :class="containerClasses" class="bg-white dark:bg-gray-800 rounded-[28px] border border-gray-200/80 dark:border-gray-700 shadow-2xl flex flex-col max-h-full overflow-hidden">
          <header v-if="$slots.header !== undefined && $slots.header !== null" class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center flex-shrink-0">
            <slot name="header" />
            <button @click="close" class="btn btn-sm btn-circle btn-ghost">
              <Icon icon="tabler:x" class="w-6 h-6" />
            </button>
          </header>

          <section class="flex-grow p-6 overflow-y-auto">
            <slot>
              <p>This is the modal content.</p>
            </slot>
          </section>

          <footer v-if="$slots.footer !== undefined && $slots.footer !== null" class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
            <slot name="footer" />
          </footer>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { computed } from 'vue';
import { Icon } from '@iconify/vue/dist/offline';

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  size: {
    type: String,
    default: '2xl',
    validator: (value) => ['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', 'full', '90screen'].includes(value) !== false
  }
});

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};

const containerClasses = computed(() => {
    if (props.size === '90screen') {
        return 'w-[90vw] h-[90vh]';
    }
    return `w-full max-w-screen-${props.size}`;
});
</script>

<style>
  .heading {
    @apply text-2xl font-semibold text-gray-800;
  }
  .heading .subtitle {
    @apply text-sm font-normal text-gray-400;
  }
  .modal-overlay {
    @apply font-lexend w-full h-screen fixed top-0 inset-0;
  }
  .modal-body {
    @apply p-5;
  }
  .modal-footer {
    @apply p-4 bg-gray-50 dark:bg-gray-700;
  }

  .slide-up-enter-active {
    transition: all 0.3s ease-out;
  }

  .slide-up-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-up-enter-from,
  .slide-up-leave-to {
    transform: translateY(-20px);
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .modal-fade-enter-from,
  .modal-fade-leave-to {
    opacity: 0;
  }
</style>
